export default {
	//base_url : 'http://localhost:80',
	base_url: 'https://api.weicell.com/think/public/index.php'
}

